import * as React from 'react';

import * as styles from './styles.css';
import { trackOpenClick } from '../../tracking';

export interface ISubscriptionButtonProps {
  setVisible(value: boolean): void;
}

export class SubscriptionButton extends React.Component<ISubscriptionButtonProps, {}> {
  public render() {
    const { setVisible } = this.props;

    return (
      <button
        type="button"
        onClick={() => {
          trackOpenClick();
          setVisible(true);
        }}
        className={styles['button']}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="12">
          <g fill="#2B87DB">
            <path d="M12.857 0h-12C.343 0 0 .343 0 .857v1.2l6.857 3.857 6.857-3.771V.857c0-.514-.343-.857-.857-.857z" />
            {/* tslint:disable-next-line:max-line-length */}
            <path d="M6.429 7.629L0 4.029v7.114c0 .514.343.857.857.857h12c.514 0 .857-.343.857-.857V4.029l-6.428 3.6c-.24.12-.617.12-.857 0z" />
          </g>
        </svg>
        Следить за объявлениями в этом доме
      </button>
    );
  }
}
